
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function TooltipHover({ children, tooltipText  }) {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      { tooltipText }
    </Tooltip>
  );

  return (
    <OverlayTrigger
        placement="top"
        overlay={renderTooltip}
    >
        { children }
    </OverlayTrigger>
  );
}

export default TooltipHover;
